import { useTranslate } from '@refinedev/core';
import { Card, Flex, Tag, Typography, theme } from 'antd';
import type { PublisherDetailOut } from '@/api/generated/schemas';
import { ShowLink } from '@/components/common/ShowLink';
import { structureRows } from './structureRows';

const { Text } = Typography;

interface PublisherStructureCardProps {
  record: PublisherDetailOut;
}

export const PublisherStructureCard = ({
  record,
}: PublisherStructureCardProps) => {
  const t = useTranslate();
  const { token } = theme.useToken();
  const rows = structureRows(record);

  return (
    <Card title={t('user_catalog.publishers.show.structure')}>
      <Flex vertical gap={token.marginXS}>
        {rows.map((row) => (
          <Flex
            key={row.key}
            gap={token.marginXS}
            align="baseline"
            style={{
              paddingLeft: row.isChild ? token.marginLG : 0,
              borderLeft: row.isChild
                ? `1px solid ${token.colorSplit}`
                : undefined,
              marginLeft: row.isChild ? token.marginXS : 0,
            }}
          >
            {row.isSelf ? (
              <>
                <Text strong>{row.name}</Text>
                <Tag>{t('user_catalog.publishers.show.this_record')}</Tag>
              </>
            ) : (
              <ShowLink resource="user_catalog.publishers" id={row.id}>
                {row.name}
              </ShowLink>
            )}
            <Text type="secondary" style={{ fontSize: token.fontSizeSM }}>
              ID {row.id}
            </Text>
          </Flex>
        ))}
      </Flex>
    </Card>
  );
};
